import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ArchiveTaskDialog } from "../../-components/archive-task-dialog"

export const Route = createFileRoute(
  "/_layout/templates/tasks/$taskId/archive",
)({
  component: ArchiveTemplateTask,
})

function ArchiveTemplateTask(): React.ReactElement {
  const { taskId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <ArchiveTaskDialog
      taskId={taskId}
      onArchived={() => navigate({ to: "/templates/tasks", search: true })}
      onCancel={() =>
        navigate({
          to: "/templates/tasks/$taskId",
          params: { taskId },
          search: true,
        })
      }
    />
  )
}
